import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useLazyMount } from '@/hooks/useLazyMount';

type LazyMountProps = {
  children: ReactNode;
  /** Shown until the section scrolls into view. */
  placeholder?: ReactNode;
  rootMargin?: string;
  className?: string;
  /** Called once when the section becomes visible. */
  onVisible?: () => void;
};

export function LazyMount({
  children,
  placeholder = null,
  rootMargin = '200px',
  className,
  onVisible,
}: LazyMountProps) {
  const { ref, visible } = useLazyMount({ rootMargin, persist: true });

  useEffect(() => {
    if (visible) onVisible?.();
  }, [visible, onVisible]);

  return (
    <div ref={ref} className={className}>
      {visible ? children : placeholder}
    </div>
  );
}
